import React from 'react';

interface LabelProps {
  fieldName: string;
  text: string;
  isRequired?: boolean;
  children: React.ReactNode;
}

const Label: React.FC<LabelProps> = ({
  fieldName,
  text,
  isRequired = false,
  children,
}) => {
  return (
    <label className="block" htmlFor={fieldName}>
      <span className="text-gray-700">{text} </span>
      {isRequired ? (
        <span className="text-red-400 font-bold text-lg">*</span>
      ) : null}
      {children}
    </label>
  );
};

export default Label;